export const queueMicrotask = window.queueMicrotask || ((fn) => Promise.resolve().then(fn))
export const setImmediate = window.setImmediate || queueMicrotask

if(!window.queueMicrotask) window.queueMicrotask = queueMicrotask
if(!window.setImmediate) window.setImmediate = setImmediate
